export default __webpack_public_path__ + "static/media/mpesa-logo.566cada1.svg";